<template>
  <div>
    <v-dialog v-model="open" max-width="600px" persistent>
      <v-card>
        <v-card-title>{{ $t('months.' + month) }} {{ $t('ui.progressRecord') }}</v-card-title>

        <v-card-text>
          <v-textarea
            v-model="localContent"
            variant="outlined"
            rows="8"
            :placeholder="$t('ui.inputProgressRecord')"
            hide-details
          ></v-textarea>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn @click="close" color="grey" text>{{ $t('ui.cancel') }}</v-btn>
          <v-btn
            @click="save"
            color="primary"
            variant="flat"
            :loading="isSaving"
            :disabled="isSaving"
          >{{ $t('ui.save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import DialogMixin from '@/mixins/DialogMixin';

export default defineComponent({
  name: 'ProgressRecordEditDialog',

  mixins: [DialogMixin],

  props: {
    month: {
      type: Number,
      required: true,
    },
    content: {
      type: String,
      default: '',
    },
    isSaving: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      localContent: '',
    };
  },

  watch: {
    content: {
      immediate: true,
      handler(newVal: string) {
        this.localContent = newVal || '';
      },
    },
    isOpen(newVal: boolean) {
      if (newVal) {
        this.localContent = this.content || '';
      }
    },
  },

  methods: {
    save() {
      this.$emit('save', this.localContent);
    },
  },
});
</script>
